import { createContext } from 'react';

const clientrdContext = createContext();

export default clientrdContext;
